import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { DBBaseOptionSet } from '../../models/stack9/BaseOptionSet';
import { BaseOptionSetDrawer } from '../BaseOptionSetDrawer/BaseOptionSetDrawer';

const S9Button = ui.S9Button.default;

const { useRefreshList } = ui;

export const config: S9ComponentConfig = {
  name: 'BaseOptionSetAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type BaseOptionSetActionProps = {
  row: DBBaseOptionSet;
};
const BaseOptionSetAction = ({ row }: BaseOptionSetActionProps) => {
  const refresh = useRefreshList();

  const [drawerState, setDrawerState] = useState<{
    id?: number;
    open: boolean;
  }>({ open: false });

  return (
    <>
      <S9Button
        type="link"
        style={{ width: '100%', textAlign: 'left' }}
        onClick={() => setDrawerState({ id: row.id, open: true })}
        label={`${row.option}`}
      />
      <BaseOptionSetDrawer
        initialValues={row}
        id={row.id}
        open={drawerState.open}
        onClose={() => {
          setDrawerState({ id: undefined, open: false });
          refresh();
        }}
      />
    </>
  );
};

export default BaseOptionSetAction;
